import { render, staticRenderFns } from "./privacy2.vue?vue&type=template&id=3e3eb42c&scoped=true&"
import script from "./privacy2.vue?vue&type=script&lang=js&"
export * from "./privacy2.vue?vue&type=script&lang=js&"
import style0 from "./privacy2.vue?vue&type=style&index=0&id=3e3eb42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3eb42c",
  null
  
)

export default component.exports